module.exports = __webpack_public_path__ + "static/media/uk-flag.5db9fea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uk-flag.svg
// module id = 5288
// module chunks = 11